module.exports = __webpack_public_path__ + "static/media/hailey.32b1fe4b.jpg";